// extracted by mini-css-extract-plugin
export default {"FundoModal":"estilo_FundoModal__UZZxr","Modal":"estilo_Modal__MfYuU","ImgStatus":"estilo_ImgStatus__HEoje","Mensagem":"estilo_Mensagem__1rbwC"};